import React, { Component } from "react";
import Modal from "react-responsive-modal";
import Page from "../2/Controls/Page";
import PageSection from "../2/Controls/PageSection";
import {
  connectQz,
  listQzPrinters,
  savePrinterName,
  getSavedPrinterName,
  printRawCommandToQz,
  printHtmlLabelsToQz,
} from "./qzPrintService";
import { generateBarcodeCommands } from "./zplMapper";
import { generateLabelHtmlPages, getPageDimensionsMm } from "./htmlLabelMapper";
var AsyncTypeahead = require("react-bootstrap-typeahead").AsyncTypeahead;

class BarcodePrint extends Component {
  constructor() {
    super();
    this.state = {
      data: null,
      transactionType: "",
      transactionNo: "",
      storeID: "",
      printDataList: [],
      toggleSearch: false,
      productsTypeAheadOptions: [],
      isProductTypeAheadLoading: false,
      productsTypeAheadSelected: [],
      queryText: "",
      error: "",
      totalQty: 0,
      showError: false,
      customField1DisplayName: "Custom Field 1",
      customField2DisplayName: "Custom Field 2",
      customField3DisplayName: "Custom Field 3",
      customField4DisplayName: "Custom Field 4",
      customField5DisplayName: "Custom Field 5",
      customField6DisplayName: "Custom Field 6",
      customField1Selected: false,
      customField2Selected: false,
      barcodeSetting: null,
      qzPrinters: [],
      qzPrinterName: "",
      qzPrinting: false,
      qzConnecting: false,
      qzConnected: false,
      qzStatusMsg: "",
      showPrintModal: false,
    };
    this.onNoOfPrintsChange = this.onNoOfPrintsChange.bind(this);
    this.onChangeCustomField1 = this.onChangeCustomField1.bind(this);
    this.onChangeCustomField2 = this.onChangeCustomField2.bind(this);
    this.onRemoveLineItem = this.onRemoveLineItem.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onProductSelected = this.onProductSelected.bind(this);
    this.onProductTypeAheadSearch = this.onProductTypeAheadSearch.bind(this);
    this.onProductBarCodeSearch = this.onProductBarCodeSearch.bind(this);
    this.onConnectQzPrinters = this.onConnectQzPrinters.bind(this);
    this.onQzPrinterChange = this.onQzPrinterChange.bind(this);
    this.onPrintQz = this.onPrintQz.bind(this);
    this.onOpenPrintModal = this.onOpenPrintModal.bind(this);
    this.onClosePrintModal = this.onClosePrintModal.bind(this);
  }

  componentDidMount() {
    this.props
      .getBarcodeSettingDetails(this.props.user.store.key)
      .then((barcodeSetting) => {
        if (barcodeSetting && barcodeSetting.PrintFields) {
          let printFields = barcodeSetting.PrintFields;
          this.setState({
            customField1Selected: printFields.some(
              (f) => f.FieldName === "CustomField1" && f.FieldSelected
            ),
            customField2Selected: printFields.some(
              (f) => f.FieldName === "CustomField2" && f.FieldSelected
            ),
          });
        }
        // Kept separately from the state above so the USB print button has
        // the full settings object (margins, barcode height, etc.), not
        // just the two customField flags read out of it above.
        this.setState({ barcodeSetting: barcodeSetting || null });
      });

    // Label printing goes through QZ Tray (local print agent, see
    // qzPrintService) — connection is only attempted when Print is clicked
    // (onOpenPrintModal), not on page load, so opening this page doesn't
    // trigger QZ Tray's permission prompt unprompted.

    this.props.config.CustomFields.map((customField) => {
      if (customField.ModuleName === "Product") {
        let customField1DisplayName =
          customField.CustomField1Name.trim() === ""
            ? "Custom Field 1"
            : customField.CustomField1Name.trim();
        let customField2DisplayName =
          customField.CustomField2Name.trim() === ""
            ? "Custom Field 2"
            : customField.CustomField2Name.trim();
        let customField3DisplayName =
          customField.CustomField3Name.trim() === ""
            ? "Custom Field 3"
            : customField.CustomField3Name.trim();
        let customField4DisplayName =
          customField.CustomField4Name.trim() === ""
            ? "Custom Field 4"
            : customField.CustomField4Name.trim();
        let customField5DisplayName =
          customField.CustomField5Name.trim() === ""
            ? "Custom Field 5"
            : customField.CustomField5Name.trim();
        let customField6DisplayName =
          customField.CustomField6Name.trim() === ""
            ? "Custom Field 6"
            : customField.CustomField6Name.trim();
        this.setState({
          customField1DisplayName: customField1DisplayName,
          customField2DisplayName: customField2DisplayName,
          customField3DisplayName: customField3DisplayName,
          customField4DisplayName: customField4DisplayName,
          customField5DisplayName: customField5DisplayName,
          customField6DisplayName: customField6DisplayName,
        });
      }
    });

    let data = this.props.location.state.data;
    let transactionType = this.props.location.state.transactionType;
    let transactionNo = "";
    let transactionDate = "";
    let printDataList = [];
    let totalQty = 0;
    if (this.props.location.state.transactionType !== "master") {
      let vendorCode = "";
      let vendorName = "";
      let storeCode = data.Store.StoreCode;
      let storeName = data.Store.StoreName;
      transactionNo = data.TransactionNo;
      // transactionDate = new Date(data.TransactionDate.seconds * 1000); //.toString().substring(0,24)
      transactionDate = new Date(data.TransactionDate);
      let months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let month = new Date(transactionDate).getMonth();
      month = months[month];
      let date =
        new Date(transactionDate).getDate() +
        "-" +
        month +
        "-" +
        new Date(transactionDate).getFullYear();
      // console.log(data);

      if (data.Vendor) {
        vendorCode = data.Vendor.VendorCode;
        vendorName =
          data.Vendor.VendorFirstName + " " + data.Vendor.VendorLastName;
      }
      // Line items save BatchMRP/BatchRetailPrice as 0 for non-batch products,
      // so take the first usable (> 0) value, else the first defined one.
      const firstPrice = (...values) => {
        const usable = values.find(
          (v) => v !== undefined && v !== null && String(v) !== "" && Number(v) > 0
        );
        if (usable !== undefined) return usable;
        const defined = values.find(
          (v) => v !== undefined && v !== null && String(v) !== ""
        );
        return defined !== undefined ? defined : "";
      };
      data.LineItems.map((m) => {
        let printData = {
          SKU: m.Product.SKU,
          Name: m.Product.Name,
          Barcode: m.Product.BarCode,
          RetailPrice: firstPrice(
            m.BatchRetailPrice,
            m.Product.RetailPrice,
            m.RetailPrice
          ),
          SupplyPrice:
            m.SupplyPrice && m.SupplyPrice !== 0
              ? m.SupplyPrice
              : m.Product.SupplyPrice,
          MRP: firstPrice(m.BatchMRP, m.Product.MRP, m.MRP),
          Category: m.Product.Category,
          SubCategory: m.Product.SubCategory,
          Brand: m.Product.Brand,
          VendorCode: vendorCode,
          VendorName: vendorName,
          StoreCode: storeCode,
          StoreName: storeName,
          TransactionNo: transactionNo,
          TransactionDate: date,
          NoOfPrints: Number(m.Qty),
        };
        printData["CustomField1"] = m.Product.hasOwnProperty("CustomField1")
          ? m.Product.CustomField1
          : "";
        printData["CustomField2"] = m.Product.hasOwnProperty("CustomField2")
          ? m.Product.CustomField2
          : "";
        printData["CustomField3"] = m.Product.hasOwnProperty("CustomField3")
          ? m.Product.CustomField3
          : "";
        printData["CustomField4"] = m.Product.hasOwnProperty("CustomField4")
          ? m.Product.CustomField4
          : "";
        printData["CustomField5"] = m.Product.hasOwnProperty("CustomField5")
          ? m.Product.CustomField5
          : "";
        printData["CustomField6"] = m.Product.hasOwnProperty("CustomField6")
          ? m.Product.CustomField6
          : "";
        totalQty += Number(m.Qty);
        
           if (this.props.registration.registration.EnablePosBillingForPincode) {
          printData.CustomField1 = "";
          printData.CustomField2 = "";
          printData.CustomField3 = "";
          printData.CustomField4 = "";
          printData.CustomField5 = "";
          printData.CustomField6 = "";
        }
        
        printDataList.push(printData);
      });
    }
    this.setState({
      data: data,
      transactionType: transactionType,
      printDataList: printDataList,
      storeID: this.props.user.store.key,
      transactionNo: transactionNo,
      totalQty: totalQty,
    });
  }

  onNoOfPrintsChange(index, value) {
    let printDataList = this.state.printDataList;
    printDataList[index].NoOfPrints = Number(value);
    let totalQty = 0;

    for (let index = 0; index < printDataList.length; index++) {
      const obj = printDataList[index];
      totalQty += obj.NoOfPrints;
    }
    this.setState({ printDataList: printDataList, totalQty: totalQty });
  }

  onChangeCustomField1(index, value) {
    let printDataList = this.state.printDataList;
    printDataList[index].CustomField1 = value;
    this.setState({ printDataList: printDataList });
  }

  onChangeCustomField2(index, value) {
    let printDataList = this.state.printDataList;
    printDataList[index].CustomField2 = value;
    this.setState({ printDataList: printDataList });
  }

  onCancel() {
    if (this.props.location.state.transactionType === "master") {

        this.props.history.push({
          pathname: "/home/product",
        });

    } else {
      this.props.history.push({
        pathname: "/home/inventory/inventorylist",
        state: { type: "list" },
      });
    }
  }

  // --- QZ Tray direct printing (new, alongside the existing onPrint flow) ---

  async onConnectQzPrinters() {
    this.setState({ qzConnecting: true, qzStatusMsg: "Connecting to QZ Tray..." });
    try {
      try {
        await connectQz();
      } catch (err) {
        throw new Error(
          "Couldn't reach QZ Tray: " + (err && err.message ? err.message : err)
        );
      }

      let printers;
      try {
        printers = await listQzPrinters();
      } catch (err) {
        throw new Error(
          "Connected, but couldn't list printers: " +
            (err && err.message ? err.message : err)
        );
      }

      const printerList = Array.isArray(printers) ? printers : [printers];
      const saved = getSavedPrinterName();
      let selected = saved && printerList.includes(saved) ? saved : "";
      if (!selected && printerList.length === 1) {
        // Only one printer on this machine — no need to make the user pick it.
        selected = printerList[0];
      }
      if (selected) {
        savePrinterName(selected);
      }
      this.setState({
        qzConnecting: false,
        qzConnected: true,
        qzPrinters: printerList,
        qzPrinterName: selected,
        qzStatusMsg: selected
          ? `Ready: ${selected}`
          : printerList.length === 0
          ? "No printers found on this computer."
          : "Select a printer below.",
      });
    } catch (err) {
      this.setState({
        qzConnecting: false,
        qzConnected: false,
        qzPrinters: [],
        qzStatusMsg: err && err.message ? err.message : "",
      });
    }
  }

  onOpenPrintModal() {
    if (this.state.printDataList.length === 0) {
      this.setState({ error: "No data to print", showError: true });
      return;
    }
    this.setState({ showPrintModal: true });
    this.onConnectQzPrinters();
  }

  onClosePrintModal() {
    this.setState({ showPrintModal: false });
  }

  onQzPrinterChange(name) {
    savePrinterName(name);
    this.setState({
      qzPrinterName: name,
      qzStatusMsg: name ? `Ready: ${name}` : "Select a printer below.",
    });
  }

  async onPrintQz() {
    if (this.state.printDataList.length === 0) {
      this.setState({ error: "No data to print", showError: true });
      return;
    }
    if (!this.state.qzPrinterName) {
      this.setState({
        qzStatusMsg: "Select a printer first, then try again.",
      });
      return;
    }
    if (!this.state.barcodeSetting) {
      this.setState({
        qzStatusMsg: "Barcode settings are still loading, try again in a moment.",
      });
      return;
    }

    this.setState({ qzPrinting: true, qzStatusMsg: "Printing..." });
    try {
      if (this.state.barcodeSetting.PrintMode === "image") {
        const pageSize = this.state.barcodeSetting.PageSize || "A4";
        const pageDimsMm = getPageDimensionsMm(this.state.barcodeSetting, pageSize);
        const pages = generateLabelHtmlPages(
          this.state.barcodeSetting,
          this.state.printDataList,
          pageSize
        );
        await printHtmlLabelsToQz(
          this.state.qzPrinterName,
          pages,
          pageDimsMm.width,
          pageDimsMm.height
        );
      } else {
        const zpl = generateBarcodeCommands(
          this.state.barcodeSetting,
          this.state.printDataList
        );
        await printRawCommandToQz(this.state.qzPrinterName, zpl);
      }
      this.setState({ qzStatusMsg: "Printed successfully." });
      this.props.getToastr("Printing barcode");
      this.onCancel();
    } catch (err) {
      this.setState({ qzStatusMsg: "Print error: " + err.message });
    } finally {
      this.setState({ qzPrinting: false });
    }
  }

  onRemoveLineItem(index) {
    let printDataList = this.state.printDataList;
    let totalQty = 0;
    printDataList.splice(index, 1);
    for (let index = 0; index < printDataList.length; index++) {
      const obj = printDataList[index];
      totalQty += obj.NoOfPrints;
    }
    this.setState({ printDataList: printDataList, totalQty: totalQty });
  }

  onProductTypeAheadSearch = (query) => {
    this.setState({ isProductTypeAheadLoading: true });
    this.props
      .getProductsForInventorySearch(
        this.props.user.user.RegistrationID,
        query,
        false
      )
      .then((result) => {
        this.setState({
          productsTypeAheadOptions: result.searchResult,
          isProductTypeAheadLoading: false,
        });
      });
  };

  onProductBarCodeSearch(evt) {
    // console.log('this.state.queryText',this.state.queryText)
    if (evt.key === "Enter") {
      var productList = this.props.config.Products.filter(
        (e) => e.SKU === this.state.queryText
      );
      // console.log('productList',productList)
      if (productList.length > 0) {
        this.onProductSelected(productList[0]);
        this.setState({ queryText: "" });
      }
    }
  }

  async onProductSelected(product) {
    let printDataList = this.state.printDataList;
    let totalQty = this.state.totalQty;
    if (
      printDataList.filter((f) => f.ProductID.trim() === product.key.trim())
        .length > 0
    ) {
      printDataList.map((m) => {
        if (m.ProductID.trim() === product.key.trim()) {
          m.NoOfPrints = m.NoOfPrints + 1;
          totalQty += 1;
        }
      });
    } else {
      let printData = {
        ProductID: product.key,
        SKU: product.SKU,
        Name: product.Name,
        Barcode: product.BarCode,
        RetailPrice: product.RetailPrice,
        SupplyPrice: product.SupplyPrice,
        MRP: product.MRP,
        Category: product.Category,
        SubCategory: product.SubCategory,
        Brand: product.Brand,
        VendorCode: "",
        VendorName: "",
        StoreCode: "",
        StoreName: "",

        NoOfPrints: 1,
      };

      printData["CustomField1"] = product.hasOwnProperty("CustomField1")
        ? product.CustomField1
        : "";
      printData["CustomField2"] = product.hasOwnProperty("CustomField2")
        ? product.CustomField2
        : "";
      printData["CustomField3"] = product.hasOwnProperty("CustomField3")
        ? product.CustomField3
        : "";
      printData["CustomField4"] = product.hasOwnProperty("CustomField4")
        ? product.CustomField4
        : "";
      printData["CustomField5"] = product.hasOwnProperty("CustomField5")
        ? product.CustomField5
        : "";
      printData["CustomField6"] = product.hasOwnProperty("CustomField6")
        ? product.CustomField6
        : "";

         if (this.props.registration.registration.EnablePosBillingForPincode) {
        printData.CustomField1 = "";
        printData.CustomField2 = "";
        printData.CustomField3 = "";
        printData.CustomField4 = "";
        printData.CustomField5 = "";
        printData.CustomField6 = "";
      }
      

      if (product.hasOwnProperty("AccessibleToSelectedStores")) {
        if (product.AccessibleToSelectedStores) {
          let storePrice = product.StoreSpecificPrices.filter(
            (f) => f.StoreID === this.props.user.store.key
          );
          if (storePrice.length > 0) {
            printData.RetailPrice = storePrice[0].RetailPrice;
            printData.SupplyPrice = storePrice[0].SupplyPrice;
            printData.MRP = storePrice[0].MRP;
          }
        }
      }
      if (product.hasOwnProperty("StoreSpecificPricing")) {
        if (product.StoreSpecificPricing) {
          let storePrice = product.StoreSpecificPrices.filter(
            (f) => f.StoreID === this.props.user.store.key
          );

          if (storePrice.length > 0) {
            printData.SupplyPrice = storePrice[0].SupplyPrice;
            printData.RetailPrice = storePrice[0].RetailPrice;
            printData.MRP = storePrice[0].MRP;
          }
        }
      }

      totalQty += 1;

      // console.log("printData", JSON.stringify(printData));
      printDataList.push(printData);
    }
    this.setState({ printDataList: printDataList, totalQty: totalQty });
  }

  render() {
    return (
      <React.Fragment>
        <Page
          {...this.props}
          title="Print Barcode"
          showPrintButton={true}
          showCancelButton={true}
          processing={this.state.qzPrinting}
          onClick={(action) => {
            if (action === "cancel") {
              this.onCancel();
            } else if (action === "print") {
              this.onOpenPrintModal();
            }
          }}
        >
          <PageSection title="">
            {/* <div className="row">
              <div className="col-md-12" style={{ marginTop: "10px" }}>
                <div className="box ">
                  <div className="box-body">
                   
                  </div>
                </div>
              </div>
            </div> */}
            <div className="row">
              <div className="col-md-4">
                {this.props.location.state.transactionType === "master" && (
                  <div
                    className="input-group"
                    style={{ width: "100%", paddingBottom: "10px" }}
                  >
                    {!this.state.toggleSearch && (
                      <AsyncTypeahead
                        autoFocus={true}
                        allowNew={false}
                        isLoading={this.state.isProductTypeAheadLoading}
                        multiple={false}
                        options={this.state.productsTypeAheadOptions}
                        labelKey="Name"
                        minLength={3}
                        onSearch={this.onProductTypeAheadSearch}
                        placeholder="Start typing or scanning to search products"
                        filterBy={["Name", "SKU", "BarCode"]}
                        dropup={false}
                        highlightOnlyResult={true}
                        selected={this.state.productsTypeAheadSelected}
                        onChange={(selected) => {
                          this.onProductSelected(selected[0]);
                          this.setState({
                            productsTypeAheadSelected: [],
                          });
                        }}
                        renderMenuItemChildren={(option, props) => (
                          <div>
                            <div>
                              <b>{option.Name}</b>
                            </div>
                            <div>{option.SKU}</div>
                          </div>
                        )}
                      />
                    )}
                    {this.state.toggleSearch && (
                      <input
                        type="text"
                        onChange={(evt) => {
                          this.setState({ queryText: evt.target.value });
                        }}
                        value={this.state.queryText}
                        onKeyPress={this.onProductBarCodeSearch}
                        placeholder="Start scanning to search products"
                        className="form-control"
                        style={{ height: "33px", fontSize: "14px" }}
                      />
                    )}
                    <div className="input-group-btn">
                      <button
                        type="button"
                        onClick={() =>
                          this.setState({
                            toggleSearch: !this.state.toggleSearch,
                          })
                        }
                        className="btn btn-default btn-lg btn-flat"
                        style={{
                          height: "33px",
                          padding: "5px 16px",
                          borderBottomLeftRadius: "0px",
                          borderTopLeftRadius: "0px",
                        }}
                      >
                        <i className="fa fa-exchange"></i>
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div className="col-md-12">
                <div
                  style={{ width: "auto", overflowX: "auto" }}
                  className="scroll2"
                >
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Barcode</th>
                        <th>Name</th>
                        <th style={{ width: "100px" }}>MRP</th>
                        <th style={{ width: "100px" }}>Retail Price</th>
                        <th style={{ width: "100px" }}>Supply Price</th>
                    
                                {(this.props.registration.registration
                          .EnablePosBillingForPincode ||
                          this.state.customField1Selected) && (
                            <th style={{ width: "150px" }}>
                              {this.state.customField1DisplayName}
                            </th>
                          )}
                        {(this.props.registration.registration
                          .EnablePosBillingForPincode ||
                          this.state.customField2Selected) && (
                            <th style={{ width: "150px" }}>
                              {this.state.customField2DisplayName}
                            </th>
                          )}
                        <th style={{ width: "100px" }}>Qty</th>
                        <th style={{ width: "60px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.printDataList.map((printData, index) => (
                        <tr key={index}>
                          <td>{printData.SKU}</td>
                          <td>{printData.Barcode}</td>
                          <td>{printData.Name}</td>
                          <td>{printData.MRP}</td>
                          <td>{printData.RetailPrice}</td>
                          <td>{printData.SupplyPrice}</td>
                         
                             {(this.props.registration.registration
                            .EnablePosBillingForPincode ||
                            this.state.customField1Selected) && (
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  onChange={(evt) =>
                                    this.onChangeCustomField1(
                                      index,
                                      evt.target.value
                                    )
                                  }
                                  value={printData.CustomField1}
                                />
                              </td>
                            )}
                          {(this.props.registration.registration
                            .EnablePosBillingForPincode ||
                            this.state.customField2Selected) && (
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  onChange={(evt) =>
                                    this.onChangeCustomField2(
                                      index,
                                      evt.target.value
                                    )
                                  }
                                  value={printData.CustomField2}
                                />
                              </td>
                            )}
                          
                        

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              onChange={(evt) =>
                                this.onNoOfPrintsChange(index, evt.target.value)
                              }
                              value={printData.NoOfPrints}
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-default btn-md"
                              onClick={() => this.onRemoveLineItem(index)}
                            >
                              <i className="glyphicon glyphicon-remove"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="8">Total Qty</td>
                        <td>{this.state.totalQty}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

          </PageSection>
        </Page>

        <Modal
          open={this.state.showPrintModal}
          onClose={this.onClosePrintModal}
          center
        >
          <div style={{ width: "340px" }}>
            <h3 style={{ marginTop: "0px" }}>Print Barcode</h3>
            <div className="box-body">
              {this.state.qzConnecting ? (
                <p style={{ fontSize: "13px" }}>Connecting to QZ Tray...</p>
              ) : !this.state.qzConnected ? (
                <div>
                  <p style={{ fontSize: "13px" }}>
                    QZ Tray isn't detected on this computer. It's a small,
                    free local app needed to print directly to your printer.
                  </p>
                  <ol style={{ fontSize: "13px", paddingLeft: "18px" }}>
                    <li>
                      Install it from{" "}
                      <a
                        href="https://qz.io/download/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        qz.io/download
                      </a>
                      .
                    </li>
                    <li>Open QZ Tray (it runs quietly in the background).</li>
                    <li>Click Retry below.</li>
                  </ol>
                  {this.state.qzStatusMsg && (
                    <p
                      style={{
                        fontSize: "11px",
                        color: "#a94442",
                        wordBreak: "break-word",
                      }}
                    >
                      {this.state.qzStatusMsg}
                    </p>
                  )}
                  <button
                    type="button"
                    className="btn btn-flat btn-md btn-default"
                    onClick={this.onConnectQzPrinters}
                  >
                    Retry
                  </button>
                </div>
              ) : this.state.qzPrinters.length === 0 ? (
                <div>
                  <p style={{ fontSize: "13px" }}>
                    QZ Tray is connected, but no printers were found on this
                    computer. Make sure your printer is plugged in, powered
                    on, and installed in Windows, then click Retry.
                  </p>
                  <button
                    type="button"
                    className="btn btn-flat btn-md btn-default"
                    onClick={this.onConnectQzPrinters}
                  >
                    Retry
                  </button>
                </div>
              ) : (
                <React.Fragment>
                  {this.state.qzPrinters.length > 1 ? (
                    <div className="form-group">
                      <label>Printer</label>
                      <select
                        className="form-control"
                        value={this.state.qzPrinterName}
                        onChange={(evt) =>
                          this.onQzPrinterChange(evt.target.value)
                        }
                      >
                        <option value="">Select a printer...</option>
                        {this.state.qzPrinters.map((name) => (
                          <option key={name} value={name}>
                            {name}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <p>
                      <b>Printer:</b> {this.state.qzPrinterName}
                    </p>
                  )}
                  <p style={{ fontSize: "12px", color: "#666" }}>
                    {this.state.qzStatusMsg}
                  </p>
                  <p style={{ fontSize: "11px", color: "#999" }}>
                    If QZ Tray asks to allow this site, check "Remember this
                    decision" so it won't ask again.
                  </p>
                </React.Fragment>
              )}
            </div>
            <div className="box-footer">
              {this.state.qzPrinters.length > 0 && (
                <button
                  type="button"
                  className="btn btn-flat btn-md btn-success pull-right"
                  disabled={this.state.qzPrinting || !this.state.qzPrinterName}
                  onClick={this.onPrintQz}
                >
                  {this.state.qzPrinting ? "Printing..." : "Print"}
                </button>
              )}
              <button
                type="button"
                className="btn btn-flat btn-md btn-default pull-right"
                style={{ marginRight: "10px" }}
                onClick={this.onClosePrintModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          open={this.state.showError}
          onClose={() => this.setState({ showError: false })}
          center
        >
          <div style={{ width: "300px" }}>
            <h3 style={{ marginTop: "0px" }}>Error</h3>
            <div className="box-body">
              <ul>{this.state.error !== "" && <li>{this.state.error}</li>}</ul>
            </div>
            <div className="box-footer">
              <button
                type="submit"
                className="btn btn-flat btn-md btn-danger pull-right"
                onClick={() => this.setState({ showError: false, error: "" })}
              >
                OK
              </button>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default BarcodePrint;
